import React from 'react';
import { B } from '../constants';
import { borderRadius, transitions } from '../designTokens';
import { useAuth } from '../AuthContext';

const PROFILE_RESPONSIVE_CSS = `
@media (max-width: 640px) {
  .profile-header { padding: 30px 0 24px !important; }
  .profile-avatar { width: 64px !important; height: 64px !important; font-size: 26px !important; }
  .profile-name { font-size: 24px !important; }
  .profile-stats { gap: 20px !important; }
}
`;

export default function MockProfileScreen({ goScreen, user }) {
  const { logout } = useAuth();
  const u = user || {};

  return (
    <div style={{ fontFamily: "'Montserrat',sans-serif", paddingBottom: 80 }}>
      <style>{PROFILE_RESPONSIVE_CSS}</style>
      <div className="profile-header" style={{ background: B.night, color: 'white', padding: '46px 0 30px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 clamp(16px, 3vw, 40px)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div className="profile-avatar" style={{ width: 84, height: 84, borderRadius: '50%', background: `linear-gradient(135deg,${B.forest},${B.mint})`, display: 'grid', placeItems: 'center', fontSize: 34, fontWeight: 800, color: 'white', flex: '0 0 auto' }}>
              {(u.name || u.email || '?')[0].toUpperCase()}
            </div>
            <div>
              <h1 className="profile-name" style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(22px, 4vw, 30px)' }}>{u.name || 'Traveler'}</h1>
              <div style={{ color: '#9fb0bd', fontSize: 14 }}>{u.email || ''}</div>
              <div className="profile-stats" style={{ display: 'flex', gap: 30, marginTop: 8 }}>
                <div><b style={{ fontSize: 20 }}>{u.tripsCount || u.tripCount || 0}</b><span style={{ fontSize: 12, color: '#9fb0bd', display: 'block' }}>Trips</span></div>
                <div><b style={{ fontSize: 20 }}>{u.followersCount || u.followers || 0}</b><span style={{ fontSize: 12, color: '#9fb0bd', display: 'block' }}>Followers</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 clamp(16px, 3vw, 40px)', paddingTop: 24 }}>
        <div style={{ borderRadius: borderRadius.lg, overflow: 'hidden' }}>
          {[
            { icon: '👤', title: 'Account', desc: 'Name, email, password', arrow: true },
            { icon: '🔔', title: 'Notifications', desc: 'Trip reminders & deals', toggle: true, on: true },
            { icon: '🌙', title: 'Dark mode', desc: 'Easier on the eyes at night', toggle: true, on: false },
            { icon: '💳', title: 'Subscription', desc: 'GreatBreak Pro — upgrade', arrow: true, onClick: () => goScreen('subscription') },
            { icon: '🎬', title: 'Creator dashboard', desc: 'Earnings & analytics', arrow: true },
          ].map((row, i) => (
            <div key={i} onClick={row.onClick}
              style={{
                display: 'flex', alignItems: 'center', gap: 14, background: 'white',
                border: '1px solid #e7e2d9', borderTop: i === 0 ? '1px solid #e7e2d9' : 'none',
                borderRadius: i === 0 ? `${borderRadius.lg} ${borderRadius.lg} 0 0` : i === 4 ? `0 0 ${borderRadius.lg} ${borderRadius.lg}` : 0,
                padding: '16px 18px', cursor: row.arrow || row.onClick ? 'pointer' : 'default',
                marginTop: i > 0 ? -1 : 0, transition: `background ${transitions.fast}`,
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#faf8f5'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'white'; }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: 'rgba(26,107,74,0.1)', color: B.forest, display: 'grid', placeItems: 'center', flex: '0 0 auto' }}>
                {row.icon}
              </div>
              <div style={{ flex: 1 }}>
                <b style={{ fontSize: 15, display: 'block' }}>{row.title}</b>
                <div style={{ fontSize: 13, color: B.muted }}>{row.desc}</div>
              </div>
              {row.toggle && (
                <div style={{ width: 44, height: 26, borderRadius: 13, background: row.on ? B.forest : '#e7e2d9', position: 'relative', transition: `background ${transitions.fast}` }}>
                  <div style={{ position: 'absolute', top: 3, width: 20, height: 20, borderRadius: '50%', background: 'white', left: row.on ? 21 : 3, transition: `left ${transitions.fast}` }} />
                </div>
              )}
              {row.arrow && <span style={{ color: B.muted, fontSize: 18 }}>→</span>}
            </div>
          ))}
        </div>

        <div style={{ marginTop: 30, textAlign: 'center' }}>
          <button onClick={() => { logout(); goScreen('auth'); }}
            style={{ background: 'none', border: '1.5px solid #e7e2d9', borderRadius: borderRadius.pill, padding: '12px 28px', fontWeight: 700, fontSize: 14, color: B.muted, cursor: 'pointer', fontFamily: "'Montserrat',sans-serif" }}>
            🚪 Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
